import React from 'react'

import Sparkline from './Sparkline'

/**
 * Stat tile: label, value, optional caption and sparkline.
 *
 * The value uses proportional figures deliberately -- tabular-nums gives every
 * digit the width of a zero, which makes a number like 121 look loose at display
 * size. Tabular figures belong in table columns, not here.
 */
const StatTile = ({ label, value, caption, spark, tone, accent, testId }) => (
    <div className={`viz-stat-tile${accent ? ` viz-stat-tile--${accent}` : ''}`}>
        <div className="viz-stat-label">{label}</div>
        <div className="viz-stat-value" data-testid={testId}>
            {typeof value === 'number' ? value.toLocaleString() : value}
        </div>
        {caption && <div className="viz-stat-caption">{caption}</div>}
        {spark && spark.length > 1 && (
            <div className="viz-stat-spark">
                <Sparkline values={spark} tone={tone} />
            </div>
        )}
    </div>
)

export const StatTileRow = ({ children }) => <div className="viz-stat-row">{children}</div>

export default StatTile
